import {AppRegistry} from 'react-native';
import App from './App';

AppRegistry.registerComponent('App', () => App);

AppRegistry.runApplication('App', {
  rootTag: document.getElementById('root'),
});

// Register the SW as early as possible so Unity/WebGL requests are intercepted
// on first-time visits (otherwise the first large .unityweb downloads can miss
// the SW and re-download on the next navigation).
const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker
    .register('/service-worker.js')
    .then(registration => {
      console.log(
        'Service Worker registered with scope:',
        registration.scope,
      );
      return registration;
    })
    .then(() => {
      // Helpful signal for debugging first-session caching:
      // - controller present => this page is controlled (fetch intercepted)
      // - controller absent  => SW may be installing; will control on activate (clientsClaim)
      const hasController = Boolean(navigator.serviceWorker.controller);
      console.log('[SW] controller present:', hasController);
    })
    .catch(error => {
      console.error('Service Worker registration failed:', error);
    });
};

registerServiceWorker();
